var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    { staticClass: "flex align-center" },
    [
      _c("SoliStatusAvatar", {
        attrs: {
          event: _vm.event,
          purchaseOption: _vm.purchaseOption,
          size: _vm.size,
          margin: "mr-9",
        },
      }),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        { staticClass: "soli-grey" },
        [
          _c("v-list-item-subtitle", [_vm._v(_vm._s(_vm.getPaymentStatus))]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-0" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.purchaseOption
                    ? `${_vm.purchaseOption.name}`
                    : `${_vm.event.type}`
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _vm.purchaseOption?.category == "drop-ins"
            ? _c("v-list-item-subtitle", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.purchaseOption.passes) +
                    " remaining"
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$page.props.staffView && !this.purchaseOption.pastDue
        ? _c(
            "v-list-item-action",
            [
              _c(
                "v-btn",
                {
                  staticClass: "shadow-blue",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.visitStore()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("local_offer"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$page.props.staffView && this.purchaseOption.pastDue
        ? _c(
            "v-list-item-action",
            [
              _c(
                "v-btn",
                {
                  staticClass: "shadow-blue",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.viewPastDueInvoice()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("payments"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "caption mt-1 soli-grey",
                  staticStyle: {
                    "white-space": "normal",
                    transform: "translateX(6px)",
                  },
                },
                [_vm._v("\n            Pay Now\n        ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }